import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledLink = styled(Link)`
   gap: 4px;
`;

StyledLink.displayName = 'StyledLink';
